export const customerReviews = [
  {
    name: 'Sarah M.',
    rating: 5,
    text: 'Sehr professionelle Arbeit! Jarek hat unser Badezimmer komplett neu gefliest. Pünktlich, sauber und perfekte Qualität.',
    date: '2024-01-20',
    project: 'Badezimmer-Renovierung'
  },
  {
    name: 'Michael K.',
    rating: 5,
    text: 'Hervorragende Handwerkskunst! Die Küchen-Rückwand wurde perfekt verlegt. Faire Preise und termingerechte Fertigstellung.',
    date: '2024-01-18',
    project: 'Küchen-Rückwand'
  },
  {
    name: 'Anna B.',
    rating: 5,
    text: 'Fantastischer Service von A bis Z! Das Gäste-WC sieht jetzt traumhaft aus. Sehr freundlich und zuverlässig!',
    date: '2024-01-15',
    project: 'Gäste-WC'
  }
];
